import { Switch } from "@/components/ui/switch";

/**
 * Three side-by-side toggle cards: property scope, include vendors, and
 * TCPA consent gate. `onDirty` is called whenever a toggle flips so the
 * parent can clear the stale preview banner.
 */
export function AudienceControls({
  scopeAll, setScopeAll,
  includeVendors, setIncludeVendors,
  consentOnly, setConsentOnly,
  currentPropertyName, busy, onDirty,
}) {
  const flip = (setter) => (v) => { setter(v); onDirty(); };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div className="flex items-center justify-between rounded-md border border-white/10 p-3">
        <div>
          <div className="text-sm font-medium">Scope</div>
          <div className="text-xs text-zinc-500">
            {scopeAll ? "All properties" : (currentPropertyName || "Current property")}
          </div>
        </div>
        <Switch data-testid="sms-broadcast-scope-all" checked={scopeAll}
                onCheckedChange={flip(setScopeAll)} disabled={busy} />
      </div>
      <div className="flex items-center justify-between rounded-md border border-white/10 p-3">
        <div>
          <div className="text-sm font-medium">Include vendors</div>
          <div className="text-xs text-zinc-500">Residents always included</div>
        </div>
        <Switch data-testid="sms-broadcast-include-vendors" checked={includeVendors}
                onCheckedChange={flip(setIncludeVendors)} disabled={busy} />
      </div>
      <div className="flex items-center justify-between rounded-md border border-white/10 p-3">
        <div>
          <div className="text-sm font-medium">Consent required</div>
          <div className="text-xs text-zinc-500">TCPA guard</div>
        </div>
        <Switch data-testid="sms-broadcast-consent-only" checked={consentOnly}
                onCheckedChange={flip(setConsentOnly)} disabled={busy} />
      </div>
    </div>
  );
}
